import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../shared/store/selected-entity.feature';
import { GroupeÉtapesÀLaCarte } from '../../models/groupe-étapes-à-la-carte.model';
import { avecMéthodesGroupeÉtapes } from './groupe-étapes-à-la-carte.methods';

export const GroupeÉtapesÀLaCarteStore = signalStore(
  { providedIn: 'root' },
  withEntities<GroupeÉtapesÀLaCarte>(),
  withSelectedEntity(),
  avecMéthodesGroupeÉtapes(),
);
